import moment from "moment";

interface ExpandArgs {
  startDate: string;
  endDate: string;
  excludedDates: string[];
}

export function expandChangedDates({
  startDate,
  endDate,
  excludedDates,
}: ExpandArgs): string[] {
  const start = moment(startDate, "YYYY-MM-DD", true);
  const end = moment(endDate, "YYYY-MM-DD", true);
  if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
    return [];
  }
  const excluded = new Set(excludedDates);
  const out: string[] = [];
  const cursor = start.clone();
  while (!cursor.isAfter(end, "day")) {
    const iso = cursor.format("YYYY-MM-DD");
    if (!excluded.has(iso)) out.push(iso);
    cursor.add(1, "day");
  }
  return out;
}

export function getMonthsForDates(
  dates: string[]
): { month: string; year: string }[] {
  const seen = new Set<string>();
  const result: { month: string; year: string }[] = [];
  for (const d of dates) {
    const m = moment(d, "YYYY-MM-DD", true);
    if (!m.isValid()) continue;
    const key = m.format("MM-YYYY");
    if (seen.has(key)) continue;
    seen.add(key);
    result.push({ month: m.format("MM"), year: m.format("YYYY") });
  }
  return result;
}
